/**
 * Shared utility helpers for Lending Report components and PDF export.
 */

export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getMonthLabel = (monthStr?: string): string => {
    if (!monthStr) return '';
    const parts = monthStr.split('-');
    const m = parseInt(parts.length > 1 ? parts[1] : parts[0], 10);
    return MONTH_NAMES[m - 1] || monthStr;
};

export const formatShort = (val: number): string => {
    if (val >= 100000) return `${(val / 100000).toFixed(1)}L`;
    if (val >= 1000) return `${(val / 1000).toFixed(0)}K`;
    return val.toString();
};

export const formatPeriod = (dateStr: string): string => {
    const [y, m] = dateStr.split('-');
    const monthIdx = parseInt(m, 10) - 1;
    return `${MONTH_NAMES[monthIdx] || m} ${y}`;
};

export const formatDate = (dateStr: string): string => {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const day = String(d.getDate()).padStart(2, '0');
    return `${day} ${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
};
